<template>
  <div class="w-100 mt-3">
    <div
      class="border rounded p-3 d-flex justify-content-between align-items-center flex-nowrap"
    >
      <div class="d-flex flew-row justify-content-start">
        <div class="mr-3">
          <HMPhotoIcon
            :instructor="{ image: '/assets/images/avatar.svg' }"
            size="40px"
          />
        </div>
        <div>
          <div class="c-charcoal">{{ student.full_name }}</div>
          <div class="text-lowercase smallest">
            {{ $t('EVENTS.LABEL.STUDENT') }}
          </div>
        </div>
      </div>
      <div class="d-flex">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventStudentComponent',
  props: {
    student: {
      type: Object,
    },
  },
};
</script>

<style scoped></style>
